<template>
  <div class="sub-comment-item">
    <span class="username item-text ellipsis">{{info.UserName}}</span>
    <span>
      <span class="item-text author-icon" v-if="info.UserId == articleAuthorId">作者</span>
    </span>
    <span class="item-text">：</span>
    <flodSpan :content='info.Content'></flodSpan>
    <div class="comment-img-box" v-if="info.ImgList && info.ImgList.length">
      <img v-for="(comImg,idx) in info.ImgList" :key="idx" class="comment-img" :src="comImg">
    </div>
  </div>
</template>
<script>
import flodSpan from '@/components/comment/flodSpan.vue'
export default {
  name: 'subCommentBlock',
  components: {
    flodSpan
  },
  props: {
    info: {
      required: true,
      default: () => {
        return {
          Id: 0,
          AppId: 0,
          Module: "",
          SourceId: "",
          Content: "",
          ParentId: 0,
          UserId: 0,
          UserName: "",
          Avatar: "",
          GoodNum: 0,
          RecommendNum: 0,
          AbuseNum: 0,
          Creator: 0,
          CreateTime: "",
          Modifier: 0,
          ModifiedTime: "",
          Deleted: true,
          ImgList: ["", "", "", "", "", ""],
          ReplyCount: 0,
          AuthorId: 0,
          Children: []
        };
      }
    },
    articleAuthorId: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
    };
  },
  
};
</script>
<style lang='scss' scoped>
.sub-comment-item {
  line-height: 24px;
  vertical-align: bottom;
  .username {
    display: inline-block;
    font-weight: bold;
    padding-right: 8px;
    max-width: 120px;
  }
  .item-text {
    font-size: $font-size-normal;
    vertical-align: bottom;
  }
  .author-tag {
    vertical-align: bottom;
  }
  .comment-img-box {
    display: flex;
    flex-wrap: wrap;
    margin-right: -12px;
    max-width: 220px;
    margin-top: 12px;

    .comment-img {
      width: 60px;
      height: 60px;
      margin-right: 12px;
      margin-bottom: 12px;
    }
  }
  .author-icon {
    font-size: 12px;
    border-radius:3px;
    line-height: 24px;
    padding: 0 3px;
    color: $red;
    border: 1px solid $red;
  }
}
</style>